'use strict';

/* @ngInject */
export default class ConfirmDeleteRuleModalController {
	public $uibModalInstance: any;
	public okFunction: any;

  constructor($uibModalInstance, okFunction) {

    this.$uibModalInstance = $uibModalInstance;
    this.okFunction = okFunction;
  }


  cancel() {
    this.$uibModalInstance.close();
  };

  ok() {
    this.$uibModalInstance.close();
    this.okFunction();
  };

}
